module.exports = __webpack_public_path__ + "img/Nanjamonja_EN.59e82d0a.jpg";